import { IconProps } from '@euler/app/components/icons/types';
import { FC, memo } from 'react';
import Svg, { Path } from 'react-native-svg';

export const AboutIcon: FC<IconProps> = memo(
  ({ width, height, size, color, style }) => {
    return (
      <Svg
        width={width ?? size}
        height={height ?? size}
        viewBox="0 0 72 72"
        style={style}
      >
        <Path
          d="M36 2.11765C17.2891 2.11765 2.11768 17.2891 2.11768 36C2.11768 54.7109 17.2891 69.8824 36 69.8824C54.711 69.8824 69.8824 54.7109 69.8824 36C69.8824 17.2891 54.711 2.11765 36 2.11765ZM36 64.1345C20.4656 64.1345 7.86558 51.5345 7.86558 36C7.86558 20.4655 20.4656 7.86554 36 7.86554C51.5345 7.86554 64.1345 20.4655 64.1345 36C64.1345 51.5345 51.5345 64.1345 36 64.1345ZM36.4236 23.8462C40.432 23.8462 43.1547 26.4025 43.4572 30.1538C43.4799 30.4714 43.7446 30.7134 44.0622 30.7134H48.3504C48.5471 30.7134 48.7059 30.5546 48.7059 30.358C48.7059 23.8008 43.5328 19.2101 36.4009 19.2101C28.0891 19.2101 23.2941 24.8218 23.2941 34.0941V38.0496C23.2941 47.2538 28.0891 52.7899 36.4009 52.7899C43.5101 52.7899 48.7059 48.3429 48.7059 42.0958C48.7059 41.8992 48.5471 41.7403 48.3504 41.7403H44.0547C43.737 41.7403 43.4799 41.9824 43.4496 42.2924C43.132 45.779 40.4168 48.1765 36.416 48.1765C31.4773 48.1765 28.6941 44.5538 28.6941 38.0723V34.0941C28.7017 27.5143 31.4925 23.8462 36.4236 23.8462V23.8462Z"
          fill={color}
        />
      </Svg>
    );
  },
);
